import Swal from 'sweetalert2';

const confirmVariantClassMap = {
  primary: 'swal2-btn-variant-primary',
  danger: 'swal2-btn-variant-danger',
  success: 'swal2-btn-variant-success',
  neutral: 'swal2-btn-variant-neutral'
};

const cancelVariantClassMap = {
  default: 'swal2-btn-variant-cancel',
  subtle: 'swal2-btn-variant-cancel-subtle'
};

const getCurrentTheme = () => {
  if (typeof document === 'undefined') {
    return 'light';
  }
  return document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
};

const applyThemeOptions = (options = {}) => {
  const {
    confirmVariant = 'primary',
    cancelVariant = 'default',
    customClass = {},
    ...restOptions
  } = options;

  const theme = getCurrentTheme();
  const background = restOptions.background ?? (theme === 'dark' ? '#0f172a' : '#ffffff');
  const color = restOptions.color ?? (theme === 'dark' ? '#e2e8f0' : '#0f172a');

  const mergedCustomClass = {
    popup: `swal2-popup-theme ${customClass.popup ?? ''}`.trim(),
    title: `swal2-title-theme ${customClass.title ?? ''}`.trim(),
    htmlContainer: `swal2-html-theme ${customClass.htmlContainer ?? ''}`.trim(),
    confirmButton: `swal2-btn swal2-btn-confirm ${confirmVariantClassMap[confirmVariant] || confirmVariantClassMap.primary} ${customClass.confirmButton ?? ''}`.trim(),
    cancelButton: `swal2-btn swal2-btn-cancel ${cancelVariantClassMap[cancelVariant] || cancelVariantClassMap.default} ${customClass.cancelButton ?? ''}`.trim(),
    denyButton: `swal2-btn swal2-btn-cancel ${cancelVariantClassMap[cancelVariant] || cancelVariantClassMap.default} ${customClass.denyButton ?? ''}`.trim(),
    actions: `swal2-actions-theme ${customClass.actions ?? ''}`.trim()
  };

  if (restOptions.showCancelButton === false) {
    delete mergedCustomClass.cancelButton;
  }

  return {
    buttonsStyling: false,
    ...restOptions,
    background,
    color,
    customClass: mergedCustomClass
  };
};

export const showAlert = (options = {}) => Swal.fire(applyThemeOptions(options));

export const showSuccess = (title, text, options = {}) => showAlert({
  icon: 'success',
  title: title ?? 'สำเร็จ',
  text,
  confirmVariant: 'success',
  ...options
});

export const showError = (title, text, options = {}) => showAlert({
  icon: 'error',
  title: title ?? 'เกิดข้อผิดพลาด',
  text,
  confirmVariant: 'danger',
  ...options
});

export const showWarning = (title, text, options = {}) => showAlert({
  icon: 'warning',
  title: title ?? 'แจ้งเตือน',
  text,
  confirmVariant: 'info',
  ...options
});

export const showInfo = (title, text, options = {}) => showAlert({
  icon: 'info',
  title,
  text,
  ...options
});

export const showConfirm = ({
  title,
  text,
  html,
  icon = 'question',
  confirmText = 'ตกลง',
  cancelText = 'ยกเลิก',
  confirmVariant = 'primary',
  cancelVariant = 'default',
  ...options
} = {}) => showAlert({
  title,
  text,
  html,
  icon,
  confirmButtonText: confirmText,
  cancelButtonText: cancelText,
  confirmVariant,
  cancelVariant,
  showCancelButton: true,
  focusConfirm: false,
  reverseButtons: true,
  ...options
});

export const showDeleteConfirm = (options = {}) => showConfirm({
  icon: 'warning',
  confirmVariant: 'danger',
  reverseButtons: true,
  ...options
});

export default Swal;
